<div class="ltms-chat-panel">
    <div class="ltms-chat-container">
        <div class="ltms-chat-notification" [class.show]="showNotification"> {{message}} </div>
        <div class="ltms-chat-history" id="ltms-chat-history" [class.chat-disabled]="!replyBackAllowed">
            <div class="ltms-chat-messages" id="ltms-chat-messages">
                <div class="ltms-chat-message-row" *ngFor="let comment of comments">
                    <div class="ltms-chat-message-box" *ngIf="comment.commented_by_type == 1 && !comment.is_deleted">
                        <div class="ltms-message-column">
                            <div class="ltms-chat-message-header" >
                                <div class="ltms-user-detail">
                                    <div class="ltms-user-name ltms-recipient" *ngIf="!isSocial">{{customerDetails.name || comment.user_name || comment.user.name}}</div>
                                    <div class="ltms-user-name ltms-recipient" *ngIf="isSocial">{{(comment.user._id == conversationProfiles.responder_id) ? (customerDetails.name || conversationProfiles["responder_name"]) : (customerDetails.name || comment.user.name)}}</div>
                                    <div class="ltms-message-date">
                                        {{ comment.created_date | date:'dd MMM' }} '{{ comment.created_date | date:'yy' }}, {{ comment.created_date | date:'hh:mm a' }}
                                    </div>
                                </div>
                            </div>
                            <div class="ltms-chat-attatchment-list" *ngIf="comment.attachments && comment.attachments.length">
                                <div class="ltms-file-list" *ngFor="let attachment of comment.attachments">
                                    <span class="file-name">{{attachment.name}}</span><span>{{attachment.ext}}</span><img (click)="downloadAttachment(attachment.value)" src="assets/images/download-file.svg"/>
                                </div>
                            </div>
                            <div class="ltms-chat-message" [innerHTML]="comment.comment_text"></div>
                        </div>
                        <div class="ltms-message-column ltms-chat-spacer"></div>
                    </div>
                    <div class="ltms-chat-message-box" *ngIf="comment.commented_by_type == 2 && !comment.is_deleted">
                        <div class="ltms-message-column ltms-chat-spacer"></div>
                        <div class="ltms-message-column">
                            <div class="ltms-chat-message-header" [class.active-message]="comment.isNewComment">
                                <div class="ltms-user-detail">
                                    <div class="ltms-user-name" *ngIf="!isSocial"> {{comment.user.name}}</div>
                                    <div class="ltms-user-name"  *ngIf="isSocial"> {{comment.user_name}}</div>
                                    <div class="ltms-message-date">
                                        {{ comment.created_date | date:'dd MMM' }} '{{ comment.created_date | date:'yy' }}, {{ comment.created_date | date:'hh:mm a' }}
                                    </div>
                                </div>
                                <div class="ltms-chat-button-group" >
                                    <button class="ltms-undo-button" (click)="undoComment(comment)" *ngIf="comment.isNewComment">
                                        <img class="default-undo-icon" src="assets/images/undo-message.svg"/>
                                        <img class="active-undo-icon" src="assets/images/undo-message-active.svg"/>
                                        Undo Send
                                    </button>
                                </div>
                            </div>
                            <div class="ltms-chat-attatchment-list" *ngIf="comment.attachments && comment.attachments.length">
                                <div class="ltms-file-list" *ngFor="let attachment of comment.attachments">
                                    <span class="file-name">{{attachment.name}}</span><span>{{attachment.ext}}</span> <img (click)="downloadAttachment(attachment.value)" src="assets/images/download-file.svg"/>
                                </div>
                            </div>
                            <div class="ltms-chat-message" [innerHTML]="comment.comment_text"></div>
                        </div>
                    </div>
                    <div class="ltms-chat-message-box deleted-message" *ngIf="comment.is_deleted">
                        <div class="ltms-deleted-message">
                            <img src="assets/images/deleted-message.svg" />
                            Message deleted
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="ltms-chat-footer" id="ltms-chat-footer"  *ngIf="replyBackAllowed">
            
            <div class="ltms-message-box">
                <input type="file"  id="litmus-chat-attatchment"  multiple="multiple"  (change)="updateAttatchment($event)">
                <label for="litmus-chat-attatchment" class="attachment-button" *ngIf="feedAttachmentEnabled">
                    <span class="attatchment-tooltip"> Attachments: .jpg, .jpeg, .png, .pdf, .docx, .doc, .xls, .xlsx, .csv. Max file size: 3MB each. Max 5 files.</span>
                    <img src="assets/images/attachment.svg">
                </label>
                <input class="input-box" [(ngModel)]="comment" (keyup)="onCommentChange($event)" placeholder="Write your message here" type="text">
                <button class="sent-button" [disabled]="!isSentButtonEnabled" (click)="commentPost(comment)">
                    <img src="assets/images/sent.svg" />
                </button>
            </div>
            <div class="litmus-chat-files" *ngIf="fileList && fileList.length">
                <div class="litmus-chat-file" *ngFor="let file of fileList">
                    {{file.name}} <img src="assets/images/download-file.svg">
                </div>
            </div>
        </div>
    </div>
</div>
<div class="alert-message-notification-container" *ngIf="showAlertMessage">
    <div class="alert-message-notification">
        <div class="alert-message">
            Are you sure you want to send this message? Message can be unsent within {{undotimeText}} after sending.
        </div>
        <div class="alert-message-control">
            <div class="do-not-show-again">
                <input type="checkbox" [(ngModel)]="doNotShow" id="okay_do_not_show_on_this_machine">
                <label for="okay_do_not_show_on_this_machine">Don’t show again</label>
            </div>
            <button class="cancel-button" (click)="cancelMessage()"> Cancel</button>
            <button class="send-button" (click)="sendMessage()"> Send</button>
        </div>
    </div>
</div>